import {useCallback} from 'react'
import {useDispatch} from 'react-redux'

import * as HookAction from '../actions/subscriptionTransactionAction'

export const ActionInit = () => {
    const dispatch = useDispatch()
    return useCallback(
        () => dispatch(HookAction.subscriptionTransactionInit()),
        [dispatch]
    )
}

export const ActionGetListSubscriptionTransaction = () => {
    const dispatch = useDispatch()
    return useCallback(
        (filters) => dispatch(HookAction.subscriptionTransactionListAction(filters)),
        [dispatch]
    )
}

export const ActionUpdateSubscriptionTransaction = () => {
    const dispatch = useDispatch()
    return useCallback(
        (params) => dispatch(HookAction.subscriptionTransactionUpdateDataAction(params)),
        [dispatch]
    )
}

export const ActionMasterData = () => {
    const dispatch = useDispatch()
    return useCallback(
        (params) => dispatch(HookAction.subscriptionTransactionMasterDataAction(params)),
        [dispatch]
    )
}
